<div class="page-wrapper">
    <div class="flex-el" style="align-items: flex-start;">
        <div class="left-menu">

            <div class="title mt-2">Catalog</div>

            <div [ngClass]="{'menu-section':true, 'active': item.name == 'Designations'}" *ngFor="let item of settingsList" >
                <div class="menu-icon">
                    <mat-icon fontSet="material-icons-outlined">{{item.icon}}</mat-icon>
                </div>
                <div class="menu-context">
                    <div class="menu-title">{{item.name}}</div>
                    <div class="menu-description">{{item.description}}</div>
                </div>
            </div>
        </div>
        <div class="right-menu">
            <div class="table-wrapper">

                <div class="flex-btw mt-3">
                    <div class="title">Designation</div>
        
                    <button mat-button color="primary" (click)="addUser()">
                        <mat-icon>add</mat-icon> 
                        Add Designation
                    </button>
                </div>
                <table mat-table [dataSource]="listData"  class="full-width cabsol-table">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Name </th>
                        <td mat-cell *matCellDef="let row">
                            {{row.name}}
                        </td>
                    </ng-container>
        
                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef> Date Created </th>
                        <td mat-cell *matCellDef="let row">{{row.datecreated}}</td>
                    </ng-container>
        
                    <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef> Code </th>
                        <td mat-cell *matCellDef="let row" >{{row.code}}</td>
                    </ng-container>
        
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <button mat-icon-button [matMenuTriggerFor]="menu">
                                <mat-icon>more_horiz</mat-icon>
                            </button>
                
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item>Edit</button>
                                <button mat-menu-item>Delete</button>
                            </mat-menu>
                        </td>
                    </ng-container>
                      
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row class="row-table rower" *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
        
            </div>
            <mat-paginator #paginator style="position: sticky; bottom: 0; background: transparent;"
            showFirstLastButtons
                [length]="userList.length"
                [pageIndex]="0"
                [pageSize]="25"
                [pageSizeOptions]="[5, 10, 25, 50, 100, 250]">
            </mat-paginator>

        </div>
    </div>
    <!-- <div class="title">Catalogue</div> -->
</div>